'use strict';
const angular = require('angular');

export default angular.module('appApp.statuspills', [])
  .directive('statuspills', function() {
    return {
      template: require('./statuspills.html'),
      restrict: 'EA',
      scope: {
        status: '=', // Current status string ('Compliant', 'Needs Work', 'Not Compliant', etc.)
        rowData: '=', // Entire data object for the row 
        onUpdate: '&', // Function to call when a status is selected ('&' allows the directive to execute a function in parent scope)
        userRole: '=' // Pass the user role
      },
      link: function(scope, element, attrs) {
        // --- Helper Functions ---

        // Function to determine the CSS class based on the status string
        scope.getStatusClass = function(status) {
          switch (status ? status.toLowerCase() : '') {
            case 'consistent':
              return 'status-pill--compliant';
            case 'in review':
              return 'status-pill--in-review';
            case 'needs work':
              return 'status-pill--needs-work';
            case 'not consistent':
              return 'status-pill--not-compliant';
            default:
              // Default or handle unrecognized statuses
              return 'status-pill--not-compliant'; // Or some default class
          }
        };

        scope.isDisabled = function() {
          // Return true to disable the dropdown if user is not an administrator
          return scope.userRole !== 'Administrator';
        };

        // Function to format the status string for display (optional, but good practice)
        scope.formatStatus = function(status) {
            // Example: Capitalize words if needed, or handle null/undefined
            if (!status) return 'Select Status'; // Or 'Not Set', etc.

            // Simple title case for display
            return status.toLowerCase()
                         .split(' ')
                         .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                         .join(' ');
        };

        // --- Action Function ---
        
        // This function is called when a dropdown item is clicked
        scope.updateStatus = function(newStatus) {

          // Do not update if user is not an admin
          if (scope.isDisabled()) {
            return;
          }
          // Check if the status is actually changing
          if (scope.status === newStatus) {
            return; // Do nothing if the status is the same
          }

          // Call the parent function passed via the 'onUpdate' binding
          // We pass an object where keys match the parameter names
          // expected by the function signature in the parent HTML attribute.
          scope.onUpdate({
            row: scope.rowData,   // Pass the row data object
            newStatus: newStatus  // Pass the newly selected status string
          });

          // Note: The parent function `updateSubmissionStatus` handles the actual
          // scope.status update optimistically and reverts on error.
          // The '=' binding for 'status' will reflect that change here automatically.
        };
        
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/statuspills/statuspills.directive.js